// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__rh5ki","modalForm":"UpgradeEpcsModal_modalForm__2BD0n","modalFooter":"UpgradeEpcsModal_modalFooter__1L9wc"};